import store from "@/store"
import { Message } from "element-ui";

export default (to, from, next) => {
// console.log(to)
  // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  if (to.name == null) {
    return next({ name: "index" });
  }
  next();
}


// WEBPACK FOOTER //
// ./src/router/beforeEach.js